import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {Helmet} from 'react-helmet';
import {getLabels} from '../../laws/selectors';

import {LANGUAGES} from '../../../constants/dia';
import Headpart from "../components/Headpart";

let messages = {};
LANGUAGES.forEach(lang => {
  messages[lang] = require('../../../i18n/' + lang + '.js').default;
});

import {updateIntl} from 'react-intl-redux';
import Footer from "../components/Footer";


class App extends React.Component {
  constructor(props) {
    super(props);
    let language = this.props.params.lang;
    if (language !== this.props.intl.locale && LANGUAGES.indexOf(language) >= 0) {
      this.props.dispatch(updateIntl({locale: language, messages: messages[language].messages}));
    }
  }

  getTitle(routes, messages = {}, labels, params) {
    let lastRoute = routes[routes.length - 1];
    let message = null;
    let sequence = ['annotationId', 'articleId', 'structureId'];
    sequence.forEach(id => {
      if (!message && params[id] && labels[params[id]]) {
        message = labels[params[id]] + ' - ';
      }
    });
    if (!message) {
      message = '';
    }
    if (lastRoute.name) {
      if (lastRoute.name.indexOf(':') === 0) {
        lastRoute.name = params[lastRoute.name.slice(1)];
      }
      message += messages[lastRoute.name] || messages[lastRoute.path] || lastRoute.name || lastRoute.path || '';
    }
    return message;
  }

  render() {
    let {getTitle} = this;
    let {routes, intl, children, labels, params} = this.props;
    return (
      <div>
        <Helmet
          encodeSpecialCharacters={true}
          titleTemplate="%s | SenLex - Senate"
          defaultTitle="SenLex - Senate"
        >
          <title>{getTitle(routes, intl.messages, labels, params)}</title>

        </Helmet>
        {/*<Headpart lang={{intl}}/>*/}
        <Headpart lang={"nl"} path={this.props.location.pathname}/>

        {children}

        <Footer/>
        {/*<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/latest/css/bootstrap.min.css"/>*/}
        <link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet"/>
      </div>
    );
  }
}

App.propTypes = {
  params: PropTypes.object.isRequired,
  labels: React.PropTypes.object,
  routes: PropTypes.array.isRequired,
  intl: PropTypes.object.isRequired,
  children: PropTypes.element,
  dispatch: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  const {intl} = state;

  let labels = getLabels(state);

  return {
    intl,
    labels
  };
}

export default connect(mapStateToProps)(App);




/** WEBPACK FOOTER **
 ** ./src/modules/app/containers/App.js
 **/